import { useTheme } from "@mui/material";
import { createSxStyles } from "../../common/createSxStyles";

export const useContentStyles = (isPdf: boolean) => {
    const theme = useTheme();
    return createSxStyles({
        content: {
            display: isPdf ? "block" : "flex",
            flexDirection: "column",
            padding: theme.spacing(2),
            width: "100%",
            height: "100%",
            backgroundColor: theme.palette.grey["50"],
            borderTopLeftRadius: theme.spacing(4),
            flex: 1,
            position: "relative",
        },
        wrapper: {
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
            backgroundColor: theme.customPalette.white,
            width: "100%",
            // Beside the drawer and the rail the wrapper takes whatever is left, through layout alone. It
            // used to compute its width from React state, which made every rail width change, and each
            // frame of a drag, a full-page render; as a flex item it follows the rail's animated or
            // dragged width without React or a transition of its own.
            [theme.breakpoints.up("md")]: {
                flex: 1,
                minWidth: 0,
            },
        },
    });
};
